import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import { createOnboardingArray } from '../../utils';
import SidebarView from './components/SidebarContainer';
import { ONBOARDING_PATH } from '../../Onbording';

type Props = {
    preferencesIndex: number;
    setPreferencesIndex: (f: number) => void;
};

const OnboardingSidebar: React.FC<Props> = ({ preferencesIndex, setPreferencesIndex }) => {
    const investor = useSelector((state: RootState) => state.user.investor);
    const user = useSelector((state: RootState) => state.user.user);

    const stepperList = useMemo(() => {
        return createOnboardingArray(user, investor);
    }, [user, investor]);

    return (
        <div className="h-auto md:h-full overflow-auto md:fixed w-full md:w-1/3 lg:w-1/4 bg-[#0F2240]">
            <SidebarView
                stepperData={
                    investor?.investorType === 'Institutional'
                        ? stepperList.filter((s) => s.url !== ONBOARDING_PATH.ACCREDITED_INVESTOR)
                        : stepperList
                }
                preferencesIndex={preferencesIndex}
                setPreferencesIndex={setPreferencesIndex}
            />
        </div>
    );
};

export default OnboardingSidebar;
